module.exports = __webpack_public_path__ + "static/media/DistanceMeasurement_001.a1d10d8c.jpg";